module.exports = __webpack_public_path__ + "static/media/BASE.4b20d2ee.png";